module.exports = __webpack_public_path__ + "media/images/application/social_sharing/twitter-1551cd3b6a311b4afa19784f36e1c1f7.png";